import * as React from 'react';
import * as css from './privacy-tools.scss';
import { InjectedTranslateProps } from 'react-i18next';
import { Text, Box, TextButton, Heading } from 'wix-style-react';
import { DataHooks } from '@src/constants/data-hooks';
import { SectionComponent } from '../section.component.tsx/section.component';
import { SetupPrivacyPolicyComponent } from './setup-privacy-policy/setup-privacy-policy.container';
import { PageRoute } from '@src/types';
import { INavigationActions } from '@src/context/navigation-store/navigation-listener';
import { sendBIDoNotSellMyData, sendBIGetStartedClicked } from '@src/context/actions/bi';

interface Props extends InjectedTranslateProps, Pick<INavigationActions, 'navigateToRoute'> {
  editorUrlForDoNotSell: string;
  appInstalled: boolean;
  appEnabled: boolean;
  isADISite: boolean;
  learnMoreKBLink: string;
  isSellDataInstalled: boolean;
}

export const InnerPrivacyToolsComponent = (props: Props) => {
  const {
    t,
    editorUrlForDoNotSell,
    isSellDataInstalled,
    navigateToRoute,
    appInstalled,
    appEnabled,
    isADISite,
    learnMoreKBLink,
  } = props;

  const getStarted = !appEnabled || !appInstalled;

  const onDisplayCookieClicked = () => {
    sendBIGetStartedClicked(getStarted);
    navigateToRoute(PageRoute.BANNER_SETTINGS);
  };

  const onDoNotSellMyDataClicked = () => {
    sendBIDoNotSellMyData();
    window.open(editorUrlForDoNotSell, '_blank');
  };

  const onClickDescriptionLearnMore = () => window.open(learnMoreKBLink, '_blank');

  const renderDescriptionText = () => (
    <Text dataHook={DataHooks.PrivacyToolsDescription}>
      {t('privacy.tools.description')}
      <TextButton className={css.learnMoreButton} onClick={onClickDescriptionLearnMore}>
        {t('learn.more')}
      </TextButton>
    </Text>
  );

  const displayCookieAction = getStarted ? 'get.started' : 'edit.cookie.banner';
  const actionTextKey = isSellDataInstalled ? 'edit.link.in.editor' : 'add.link.in.editor';

  return (
    <div data-hook={DataHooks.PrivacyToolsPage} className={css.root}>
      <Box marginBottom={'36px'}>{renderDescriptionText()}</Box>
      <Box marginBottom={'36px'}>
        <Heading dataHook={DataHooks.PrivacyToolsTitle} appearance="H3">
          {t('privacy.tools.title')}
        </Heading>
      </Box>
      <SectionComponent
        dataHook={DataHooks.CookieConsentHeader}
        className={css.section}
        actionHasIcon
        title={t('display.cookie.title')}
        subtitle={t('display.cookie.subtitle')}
        actionText={t(displayCookieAction)}
        onButtonClicked={onDisplayCookieClicked}
      />
      <SetupPrivacyPolicyComponent className={css.section} />
      <SectionComponent
        actionHasIcon={true}
        dataHook={DataHooks.DoNotSellHeader}
        className={css.section}
        title={t('do.not.sell.title')}
        subtitle={t('do.not.sell.subtitle')}
        tooltip={isADISite ? t('do.not.sell.disabled.tooltip') : undefined}
        actionText={t(actionTextKey)}
        onButtonClicked={onDoNotSellMyDataClicked}
        disabled={isADISite}
      />
      <Box align={'center'} textAlign={'center'}>
        <Text className={css.disclaimerText} size={'small'} dataHook={DataHooks.DisclaimerText}>
          {t('disclaimer.text')}
        </Text>
      </Box>
    </div>
  );
};
